module.exports = __webpack_public_path__ + "img/LN_L.ba257bcf.png";